import { api } from './api';

export interface UploadedImage {
  filename: string;
  url: string;
  mimeType: string;
  sizeBytes: number;
}

export const mailTemplateImagesService = {
  async upload(file: File): Promise<UploadedImage> {
    const form = new FormData();
    form.append('file', file);
    const { data } = await api.post('/mail-template-images', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data.data as UploadedImage;
  },
};
